import { useState } from 'react';
import styles from './Main.module.css';

function Main() {
  return (
    <main style={{ padding: "20px" }}>
      <h2>Frontend Developer</h2>
      <p>
        Работаю с современным фронтенд‑стеком: HTML5, CSS3, JavaScript и React.
        В проектах стараюсь совмещать аккуратную верстку, понятный UI и чистый код,
        чтобы сайт выглядел профессионально и был удобен для пользователей.
      </p>
      <p>
        Ниже собраны небольшие интерактивные примеры: список задач, форма обратной
        связи и виджет с репозиториями GitHub. Они демонстрируют работу с
        состоянием, формами, валидацией и внешними API в рамках одного портфолио.
      </p>
    </main>
  );
}

export default Main;


